import Web3 from "web3";
import {
  metaspaceNFTMarketplaceABI,
  metaspaceNFTMarketplaceAddress,
  mldStakingAbi,
  mldStakingAddress,
  nftStakingABI,
  nftStakingAddress,
} from "./data";
import { convertedMulPrice } from "./common";
import environmentVariables from "./environmentVariables";
import axios from "axios";
import { getWeb3Provider } from "../utils/rpcProvider";
const addErrorLogs = async (type, error, address) => {
  try {
    let data = {
      type: type,
      error: error,
      user_address: address,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/add_error_log`,

      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (err) {
    console.log(err);
  }
};
export const gasEstimateUnstake = async (nftAddress, tokenId, userAddress) => {
  try {
    // const provider = new ethers.providers.JsonRpcProvider(
    //   "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    // );
    const web3 = getWeb3Provider() || new Web3(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const tokenContract = new web3.eth.Contract(
      nftStakingABI,
      nftStakingAddress
    );
    // const recipient = userAddress;
    // const estimation = await tokenContract.estimateGas.withdraw(
    //   nftStakingAddress,
    //   tokenId
    // );
    // console.log(estimation, "estimatedgas");
    const data = tokenContract?.methods
      .withdraw(nftAddress, tokenId)
      .encodeABI();

    const gasPrice = await web3.eth.getGasPrice();
    // console.log("data------------->", data, gasPrice, nftAddress, tokenId);
    // console.log(gasPrice, "-----------------gas------------------");
    const transactionObj = {
      from: userAddress,
      to: nftStakingAddress,
      data: data,
      // value: "0",
    };
    // console.log(transactionObj, "<-----------------------transactionobj");
    let gasEstimate;
    try {
      gasEstimate = await web3.eth.estimateGas(transactionObj);
      // console.log(gasEstimate,"--------------------gas estimate---------------------");
    } catch (err) {
      console.log(err, "error");
      addErrorLogs("gasEstimateUnstake", JSON.stringify(err), userAddress);
      return null;
    }

    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
  } catch (err) {
    addErrorLogs("gasEstimateUnstake", JSON.stringify(err), userAddress);
    console.log(err);
    return null;
  }
};

export const gasEstimateStake = async (nftAddress, tokenId, userAddress) => {
  try {
    const web3 = getWeb3Provider() || new Web3(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const tokenContract = new web3.eth.Contract(
      nftStakingABI,
      nftStakingAddress
    );
    const data = tokenContract?.methods.stake(nftAddress, tokenId).encodeABI();
    const gasPrice = await web3.eth.getGasPrice();
    // console.log(gasPrice, "-----------------gas------------------");
    const transactionObj = {
      from: userAddress,
      to: nftStakingAddress,
      data: data,
    };
    let gasEstimate;
    try {
      gasEstimate = await web3.eth.estimateGas(transactionObj);
      // console.log(gasEstimate,"--------------------gas estimate---------------------");
    } catch (err) {
      console.log(err);
      addErrorLogs("gasEstimateStake", JSON.stringify(err), userAddress);
      // if(err?.Error)
    }
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
  } catch (err) {
    
    addErrorLogs("gasEstimateStake", JSON.stringify(err), userAddress);
    console.log(err,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;');
  }
};

export const gasEstimateBuy = async (contract, tokenId, userAddress) => {
  try {
    // console.log("hi", "balanceofbuy");
    // console.log(
    //   contract,
    //   tokenId,
    //   userAddress,
    //   "----------------------------------"
    // );
    const web3 = getWeb3Provider() || new Web3("https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f");
    const tokenContract = new web3.eth.Contract(
      metaspaceNFTMarketplaceABI,
      metaspaceNFTMarketplaceAddress
    );
    const data = tokenContract?.methods
      .buyAtFixedPrice(contract, tokenId)
      .encodeABI();

    // console.log(data, "balanceofbuy");
    const gasPrice = await web3.eth.getGasPrice();
    // console.log(gasPrice, data, "-----------------gas------------------");
    const transactionObj = {
      from: userAddress,
      to: metaspaceNFTMarketplaceAddress,
      data: data,
    };
    let gasEstimate;

    gasEstimate = await web3.eth.estimateGas(transactionObj);
    // console.log(
    //   gasEstimate,
    //   "--------------------gas estimate---------------------"
    // );
    // console.log(gasEstimate, "balanceofbuy");
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
  } catch (err) {
    console.log(err, "balanceofbuy");
    addErrorLogs("gasEstimateBuy", JSON.stringify(err), userAddress);
  }
};
export const gasEstimateBuyForMatic = async (
  contract,
  tokenId,
  userAddress,
  price
) => {
  try {
    // console.log(
    //   contract,
    //   tokenId,
    //   userAddress,
    //   "----------------------------------"
    // );
    // const newPrice = new ethers.parseUnits(`${price}`, "ether");
    // console.log(newPrice, "balanceofbuy");
    const web3 = getWeb3Provider() || new Web3(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const newPrice = web3.utils.toWei(`${price}`, "ether");
    const tokenContract = new web3.eth.Contract(
      metaspaceNFTMarketplaceABI,
      metaspaceNFTMarketplaceAddress
    );
    const data = tokenContract?.methods
      .buyAtFixedPrice(contract, tokenId)
      .encodeABI();

    const gasPrice = await web3.eth.getGasPrice();
    // console.log(
    //   data,
    //   gasPrice,
    //   userAddress,
    //   metaspaceNFTMarketplaceAddress,
    //   "balanceofbuy"
    // );
    // console.log(gasPrice, "-----------------gas------------------");
    const transactionObj = {
      from: userAddress,
      to: metaspaceNFTMarketplaceAddress,
      data: data,
      value: `${newPrice}`,
    };
    let gasEstimate;

    gasEstimate = await web3.eth.estimateGas(transactionObj);
    // console.log(
    //   gasEstimate,
    //   "--------------------gas estimate---------------------"
    // );
    // console.log(gasEstimate, "balanceofbuy");
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
  } catch (err) {
    console.log(err, "balanceofbuy");
    addErrorLogs("gasEstimateBuyMatic", JSON.stringify(err), userAddress);
  }
};
export const gasEstimateMLDStake = async (
  contract,
  mldAmount,
  sec,
  userAddress
) => {
  try {
    const web3 = getWeb3Provider() || new Web3(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const tokenContract = new web3.eth.Contract(
      mldStakingAbi,
      mldStakingAddress
    );
    // console.log(mldAmount);
    const data = tokenContract?.methods.stake(mldAmount, sec).encodeABI();

    const gasPrice = await web3.eth.getGasPrice();
    // console.log(gasPrice, data, "-----------------gas------------------");
    const transactionObj = {
      from: userAddress,
      to: mldStakingAddress,
      data: data,
    };
    // console.log(transactionObj, "<-----------------------transactionobj");
    let gasEstimate;
    try {
      gasEstimate = await web3.eth.estimateGas(transactionObj);
      // console.log(
      //   gasEstimate,
      //   "--------------------gas estimate---------------------"
      // );
    } catch (err) {
      console.log(err, "error");
      addErrorLogs("gasEstimateMLDStake", JSON.stringify(err), userAddress);
    }
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
  } catch (err) {
    addErrorLogs("gasEstimateMLDStake", JSON.stringify(err), userAddress);
    console.log(err);
  }
};

export const gasEstimateMLDWithdraw = async (index, userAddress) => {
  try {
    const web3 = getWeb3Provider() || new Web3(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const tokenContract = new web3.eth.Contract(
      mldStakingAbi,
      mldStakingAddress
    );

    const data = tokenContract?.methods.withdraw(index).encodeABI();

    const gasPrice = await web3.eth.getGasPrice();
    // console.log(gasPrice, "-----------------gas------------------");
    const transactionObj = {
      from: userAddress,
      to: mldStakingAddress,
      data: data,
    };
    // console.log(transactionObj, "<-----------------------transactionobj");
    let gasEstimate;
    try {
      gasEstimate = await web3.eth.estimateGas(transactionObj);
      // console.log(
      //   gasEstimate,
      //   "--------------------gas estimate---------------------"
      // );
    } catch (err) {
      console.log(err, "error");
      addErrorLogs("gasEstimateMLDWithdraw", JSON.stringify(err), userAddress);
    }
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
  } catch (err) {
    addErrorLogs("gasEstimateMLDWithdraw", JSON.stringify(err), userAddress);
    console.log(err);
  }
};

export const gasEstimateListing = async (
  nftContract,
  tokenId,
  currency,
  price,
  auction,
  userAddress
) => {
  try {
    let currencyAddress;
    if (currency == "MLD") {
      currencyAddress = "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6";
    } else if (currency == "MATIC") {
      currencyAddress = "0x0000000000000000000000000000000000001010";
    } else if (currency == "USDT") {
      currencyAddress = "0xc2132D05D31c914a87C6611C10748AEb04B58e8F";
    }
    const web3 = getWeb3Provider() || new Web3(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const newPrice = convertedMulPrice(currency, price);
    const tokenContract = new web3.eth.Contract(
      metaspaceNFTMarketplaceABI,
      metaspaceNFTMarketplaceAddress
    );
    const data = tokenContract?.methods
      .listNFT(nftContract, tokenId, currencyAddress, newPrice, auction)
      .encodeABI();
    // console.log(price, data,nftContract,tokenId,currencyAddress,newPrice,auction, "priceinsidegasestimation");

    const gasPrice = await web3.eth.getGasPrice();
    // console.log(gasPrice, "-----------------gas------------------");
    const transactionObj = {
      from: userAddress,
      to: metaspaceNFTMarketplaceAddress,
      data: data,
    };

    // console.log(transactionObj, "<-----------------------transactionobj");
    let gasEstimate;
    try {
      gasEstimate = await web3.eth.estimateGas(transactionObj);
      // console.log(
      //   gasEstimate,
      //   "--------------------gas estimate---------------------"
      // );
    } catch (err) {
      console.log(err, "error");
      addErrorLogs("gasEstimateListing", JSON.stringify(err), userAddress);
    }
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
  } catch (err) {
    console.log(err);
    addErrorLogs("gasEstimateListing", JSON.stringify(err), userAddress);
  }
};

export const gasEstimateMaticTransfer = async (
  amount,
  receiveAddress,
  userAddress
) => {
  try {
    const web3 = getWeb3Provider() || new Web3(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const amountInWei = web3.utils.toWei(amount, "ether");
    const gasPrice = await web3.eth.getGasPrice();

    const transactionObj = {
      from: userAddress,
      to: receiveAddress,
      value: amountInWei,
    };

    const gasEstimate = await web3.eth.estimateGas(transactionObj);
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
  } catch (err) {
    console.log(err);
    addErrorLogs("gasEstimateMaticTransfer", JSON.stringify(err), userAddress);
  }
};

export const gasEstimateClaimRewards = async ( userAddress) => {
  try {
    const web3 = getWeb3Provider() || new Web3(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const tokenContract = new web3.eth.Contract(
      nftStakingABI,
      nftStakingAddress
    );

    const data = tokenContract?.methods.claimRewards().encodeABI();

    const gasPrice = await web3.eth.getGasPrice();
    // console.log(gasPrice, "-----------------gas------------------");
    const transactionObj = {
      from: userAddress,
      to: nftStakingAddress,
      data: data,
    };
    // console.log(transactionObj, "<-----------------------transactionobj");
    let gasEstimate;
    try {
      gasEstimate = await web3.eth.estimateGas(transactionObj);
      // console.log(
      //   gasEstimate,
      //   "--------------------gas estimate---------------------"
      // );
    } catch (err) {
      // console.log(err, "error");
      addErrorLogs("gasEstimateClaimRewards", JSON.stringify(err), userAddress);
      console.log(err?.message,err,typeof err,';;;;;;;;;;;;;;;;;;;;;;;;;;;;----------->');
    return err?.response?.data?.message||err?.message;
    }
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
  } catch (err) {
    addErrorLogs("gasEstimateClaimRewards", JSON.stringify(err), userAddress);
    console.log(err?.message,err?.response?.data?.message,';;;;;;;;;;;;;;;;;;;;;;;;;;;;----------->');
    return err?.response?.data?.message||err?.message;
  }
};
